import { render, staticRenderFns } from "./BookingIndex.vue?vue&type=template&id=bcce4d2c"
import script from "./BookingIndex.vue?vue&type=script&lang=ts"
export * from "./BookingIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports